import { render, staticRenderFns } from "./inheritor.vue?vue&type=template&id=2e223ace&scoped=true"
import script from "./inheritor.vue?vue&type=script&lang=js"
export * from "./inheritor.vue?vue&type=script&lang=js"
import style0 from "./inheritor.vue?vue&type=style&index=0&id=2e223ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e223ace",
  null
  
)

export default component.exports